var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerRedux = function SvgHamburgerRedux(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.25a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h12Zm6-6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h18Zm0-6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h18Z",
    fill: "#273943"
  })));
};
export default SvgHamburgerRedux;